import React from 'react';
import { Form } from 'react-bootstrap';

export interface RadioOption {
    id: string;
    value: string;
    label: string;
    description?: string;
}

interface RadioGroupProps {
    name: string;
    legend: string;
    options: RadioOption[];
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
    error?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
    name,
    legend,
    options,
    value,
    onChange,
    required = false,
    error
}) => {
    return (
        <div className="mb-4">
            <fieldset>
                <Form.Label as="legend" className="fw-bold mb-3">{legend}</Form.Label>
                {options.map(option => (
                    <Form.Check key={option.id} className="mb-2">
                        <Form.Check.Input
                            type="radio"
                            name={name}
                            id={option.id}
                            value={option.value}
                            checked={value === option.value}
                            onChange={onChange}
                            required={required}
                        />
                        <Form.Check.Label htmlFor={option.id}>
                            <strong>{option.label}</strong>
                            {option.description && (
                                <span className="d-block text-muted small">{option.description}</span>
                            )}
                        </Form.Check.Label>
                    </Form.Check>
                ))}
            </fieldset>
            {error && <Form.Control.Feedback type="invalid" className="d-block">{error}</Form.Control.Feedback>}
        </div>
    );
};
